import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  Input,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LetDirective } from '@directives/app-let.directive';
import { LiftStatusEnum } from '@models/check-in.models';
import { AppCopy } from '@models/cms/app.model';
import { TripDetailsCopy } from '@models/cms/trip-details.model';
import { ValidationContact } from '@models/sms-validation.model';
import { HidePipe } from '@pipes/hide/hide.pipe';
import { PassengerNamePipe } from '@pipes/passenger-name/passenger-name.pipe';
import {
  SafeHtmlPipe,
  SanitizerValueType,
} from '@pipes/safe-html/safe-html.pipe';
import { triggerDisplayFormErrors } from '@utils/form-utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {MMBHomeV6Copy} from "@models/cms/mmb-home.model";

@Component({
  selector: 'app-trip-details-validation-select-modal',
  standalone: true,
  imports: [
    PassengerNamePipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LetDirective,
    HidePipe,
    SafeHtmlPipe,
  ],
  templateUrl: './trip-details-validation-select-modal.component.html',
  styleUrls: ['./trip-details-validation-select-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripDetailsValidationSelectModalComponent {
  @Input() validationContactList: ValidationContact[];
  @Input() tripDetailsCopy: TripDetailsCopy;
  @Input() appCopy: AppCopy;
  @Input() skybidV6Copy: MMBHomeV6Copy;
  @Input() isSkybidV6enabled: boolean = false;

  @Output() selectedContact = new EventEmitter<ValidationContact | null>();

  form = new FormGroup({
    validationContact: new FormControl<string | null>(null, [
      Validators.required,
    ]),
  });

  readonly SanitizerValueType = SanitizerValueType;
  readonly LiftStatusEnum = LiftStatusEnum;

  constructor(private bsModalRef: BsModalRef) {}

  cancel(): void {
    this.bsModalRef.hide();
  }

  submit(): void {
    if (this.form.invalid) {
      triggerDisplayFormErrors(this.form);
      return;
    }

    this.selectedContact.emit(
      this.validationContactList.find(
        (c) => c.key === this.form.value.validationContact,
      ),
    );
    this.bsModalRef.hide();
  }
}
